import * as React from "react";
import { SVGProps } from "react";
const SvgLogoGemini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-gemini_svg__a)">
      <path
        d="M16 8.016A8.522 8.522 0 0 0 8.016 16h-.032A8.52 8.52 0 0 0 0 8.016v-.032A8.521 8.521 0 0 0 7.984 0h.032A8.522 8.522 0 0 0 16 7.984v.032Z"
        fill="url(#logo-gemini_svg__b)"
      />
    </g>
    <defs>
      <radialGradient
        id="logo-gemini_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(18.683 -18.972 8.079) scale(17.0305 136.421)"
      >
        <stop offset={0.067} stopColor="#9168C0" />
        <stop offset={0.343} stopColor="#5684D1" />
        <stop offset={0.672} stopColor="#1BA1E3" />
      </radialGradient>
      <clipPath id="logo-gemini_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoGemini;
